/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 * 相关 API 文档地址： http://47.105.138.6:8081/web/#/4
 */
import { extend } from 'umi-request';
import { getToken } from '@/utils/token';
import { isLocalServer } from '@/utils/utils';
import { history } from 'umi';
import { getAreaCode } from '@/utils/utils';

const defaultToken = "bcf8c134-a98d-43cf-959c-c8b836980a35";

const errorHandler = error => {
  const { response } = error;
  if (response.status === 403) {
    history.push('/auth');
  }
  return response;
}

const request = extend({
  errorHandler,
  // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
  headers: {
    // fix bug
    // 小程序和H5  header 里面都加个 source  1打卡小程序 2幸福课堂H5
    //
    "source": 2,
    "Accept": 'application/json',
    "Content-Type": "application/json;encoding=utf-8",
  }
});

request
  .interceptors
  .request
  .use(
    (url, options) => {
      const { headers } = options;
      return ({
        url,
        options: {
          ...options,
          headers: {
            ...headers,
            // token:defaultToken,
            areaCode: isLocalServer() ? 320114 : getAreaCode(),
            token: isLocalServer() ? defaultToken : getToken(),
            // areaCode: getAreaCode(),
            // token: getToken(),
          },
        }
      });
    });



export default request;
